// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    box-sizing: border-box;
  }
  
  #form {
    max-width: 500px;
  }
  
  .stripe-form {
    max-width: 500px;
    margin: 0 15px 20px;
  }
  
  label {
    color: black;
    font-size: 18px;
  }
  
  .stripe-postcode-input {
      display: block;
      border: 1px solid #979797;
      font-size: 18px;
      max-width: 100%;
      padding: 10px 14px;
      margin: 15px 0px 15px 0px;
      border-radius: 5px;
      background: #fafafa;
      color: black;
      letter-spacing: 0.025em;
      width: 500px;
    }
    
    .StripeElement {
      padding: 10px 15px 11px 10px;
      background-color: #fafafa;
      border: 1px solid #979797;
      color: black;
      font-size: 18px;
      letter-spacing: 0.025em;
      border-radius: 5px;
      margin: 15px 0px 15px 0px;
    }
  
    #cardNumber {
      padding: 10px 14px;
    }
  
    #expiry {
      padding: 10px 14px;
    }
  
    #cvc {
      padding: 10px 14px;
    }`, "",{"version":3,"sources":["webpack://./src/stripe.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;MACI,cAAc;MACd,yBAAyB;MACzB,eAAe;MACf,eAAe;MACf,kBAAkB;MAClB,yBAAyB;MACzB,kBAAkB;MAClB,mBAAmB;MACnB,YAAY;MACZ,uBAAuB;MACvB,YAAY;IACd;;IAEA;MACE,4BAA4B;MAC5B,yBAAyB;MACzB,yBAAyB;MACzB,YAAY;MACZ,eAAe;MACf,uBAAuB;MACvB,kBAAkB;MAClB,yBAAyB;IAC3B;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;IACpB","sourcesContent":["* {\r\n    box-sizing: border-box;\r\n  }\r\n  \r\n  #form {\r\n    max-width: 500px;\r\n  }\r\n  \r\n  .stripe-form {\r\n    max-width: 500px;\r\n    margin: 0 15px 20px;\r\n  }\r\n  \r\n  label {\r\n    color: black;\r\n    font-size: 18px;\r\n  }\r\n  \r\n  .stripe-postcode-input {\r\n      display: block;\r\n      border: 1px solid #979797;\r\n      font-size: 18px;\r\n      max-width: 100%;\r\n      padding: 10px 14px;\r\n      margin: 15px 0px 15px 0px;\r\n      border-radius: 5px;\r\n      background: #fafafa;\r\n      color: black;\r\n      letter-spacing: 0.025em;\r\n      width: 500px;\r\n    }\r\n    \r\n    .StripeElement {\r\n      padding: 10px 15px 11px 10px;\r\n      background-color: #fafafa;\r\n      border: 1px solid #979797;\r\n      color: black;\r\n      font-size: 18px;\r\n      letter-spacing: 0.025em;\r\n      border-radius: 5px;\r\n      margin: 15px 0px 15px 0px;\r\n    }\r\n  \r\n    #cardNumber {\r\n      padding: 10px 14px;\r\n    }\r\n  \r\n    #expiry {\r\n      padding: 10px 14px;\r\n    }\r\n  \r\n    #cvc {\r\n      padding: 10px 14px;\r\n    }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
